import React from "react";
import styles from "./PartnersPageSkeleton.module.css";

const PartnersPageSkeleton = () => {
  return (
    <div className={styles.container}>
      {/* Banner skeleton */}
      <div className={styles.banner}>
        <div className={styles.bannerContent}>
          <div className={styles.titleSkeleton}></div>
          <div className={styles.subtitleSkeleton}></div>
          <div className={styles.buttonSkeleton}></div>
        </div>
      </div>

      {/* Main message skeleton */}
      <section className={styles.mainMessage}>
        <div className={styles.titleSkeleton}></div>
        <div className={styles.textSkeleton}>
          <div className={styles.line}></div>
          <div className={styles.line}></div>
          <div className={styles.line}></div>
        </div>
      </section>

      {/* Reasons section skeleton */}
      <section className={styles.reasonsSection}>
        <div className={styles.titleSkeleton}></div>
        <div className={styles.textSkeleton}>
          <div className={styles.line}></div>
          <div className={styles.line}></div>
        </div>
        <div className={styles.reasons}>
          {[1, 2, 3].map((i) => (
            <div key={i} className={styles.reasonCard}>
              <div className={styles.iconSkeleton}></div>
              <div className={styles.cardTitleSkeleton}></div>
              <div className={styles.cardTextSkeleton}>
                <div className={styles.line}></div>
                <div className={styles.line}></div>
                <div className={styles.line}></div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Steps section skeleton */}
      <section className={styles.stepsSection}>
        <div className={styles.titleSkeleton}></div>
        <div className={styles.textSkeleton}>
          <div className={styles.line}></div>
          <div className={styles.line}></div>
        </div>
        <div className={styles.steps}>
          {[1, 2, 3].map((i) => (
            <div key={i} className={styles.stepCard}>
              <div className={styles.numberSkeleton}></div>
              <div className={styles.cardTitleSkeleton}></div>
              <div className={styles.cardTextSkeleton}>
                <div className={styles.line}></div>
                <div className={styles.line}></div>
                <div className={styles.line}></div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Form section skeleton */}
      <section className={styles.formContainer}>
        <div className={styles.formTitleSkeleton}></div>
        <div className={styles.formDescriptionSkeleton}>
          <div className={styles.line}></div>
          <div className={styles.line}></div>
        </div>

        <div className={styles.formSection}>
          <div className={styles.sectionTitleSkeleton}></div>
          <div className={styles.fieldsGrid}>
            <div className={styles.fieldSkeleton}></div>
            <div className={styles.fieldSkeleton}></div>
            <div className={styles.fieldSkeleton}></div>
            <div className={styles.fieldSkeleton}></div>
          </div>
        </div>

        <div className={styles.formSection}>
          <div className={styles.sectionTitleSkeleton}></div>
          <div className={styles.fieldsGrid}>
            <div className={styles.fieldSkeleton}></div>
            <div className={styles.fieldSkeleton}></div>
          </div>
        </div>

        <div className={styles.buttonSkeleton}></div>
      </section>
    </div>
  );
};

export default PartnersPageSkeleton;
